import Badge from 'react-bootstrap/Badge'
import { useTeamSpiritTable } from '../context/TeamSpiritTableContext'
import TeamSpiritCountryCellPair from './TeamSpiritCountryCellPair'

const TeamSpiritMatchRow = ({ row, rowCountryState }) => {
  const { countryGroups, nationalCompetition, worldCompetition, selectedGroup, currentRoundBucket, nextMatchRowId, styles, formatters } = useTeamSpiritTable()
  const scheduleLabel = row.schedule ? `vko${(row.schedule.part - 1) * 16 + row.schedule.week} (${row.schedule.day})` : '—'
  const displayScheduleLabel = row.calendarLabel || scheduleLabel
  const selection = row.schedule?.label?.match(/CC|CL/) ? nationalCompetition : worldCompetition
  const matchLabel = row.matchLabel || (row.schedule?.label ? formatters.compactMatchLabel(formatters.getScheduleLabel(row.schedule.label, selection)) : formatters.t('matchRow'))
  const isCurrentRound = Boolean(currentRoundBucket && formatters.getRoundBucketFromUtils(selectedGroup?.tournamentKind, row.matchRound) === currentRoundBucket)
  const isNextMatch = Number(row.index) === Number(nextMatchRowId)

  return (
    <tr style={{ backgroundColor: isCurrentRound ? '#fff0bf' : '#fff8dc', fontWeight: isCurrentRound || isNextMatch ? 700 : 400, outline: isNextMatch ? '3px solid #000' : undefined, outlineOffset: isNextMatch ? '-3px' : undefined }}>
      <td title="Kilpailun ottelukierros" style={{ ...styles.compactCellStyle, fontWeight: 700, width: '84px', minWidth: '84px' }}><div>{displayScheduleLabel}</div><div className="mt-1"><Badge title="Ottelun kilpailu ja kierros" bg="warning" text="dark">{matchLabel}</Badge></div></td>
      <td title="Ottelupäivä" style={{ ...styles.compactCellStyle, fontWeight: 700, width: '56px', minWidth: '56px' }}>{formatters.formatDateLabel(row.date)}</td>
      {countryGroups.map(country => <TeamSpiritCountryCellPair key={country} row={row} country={country} countryState={rowCountryState[country] || {}} />)}
    </tr>
  )
}

export default TeamSpiritMatchRow
